export const defaultProperties = {
  theme: 'light',
  placement: 'right',
  autoPlacement: true,
  alignToCenter: true,
  overlayBackdrop: false,
  maxWidth: '400px',
  height: 'auto',
  offset: 6,
  animationDuration: 100,
  animationTimingFunction: 'ease-in-out',
  animationTranslateY: '10px',
  zIndex: 1000,
  hideDelay: 100,
  showDelay: 300,
  trigger: 'hover',
  display: true,
};
